// extracted by mini-css-extract-plugin
export default {"main":"Projects_main__1jBbK","all_projects_list":"Projects_all_projects_list__DIaoY","all_projects_list_item":"Projects_all_projects_list_item__8Vmad"};